import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"

export const SectionCharityBackground = styled.div`
  position: absolute;
  top: -50px;
  width: 120%;
  height: 700px;
  background-color: ${ACTIVE_TEXT};
  transform: rotate(-1.5deg);

  @media screen and (max-width: 768px) {
    height: 800px;
    top: 0px;
  }

  @media screen and (max-width: 768px) {
    height: 650px;
    top: 0px;
  }
`



// WEBPACK FOOTER //
// ./src/components/SectionCharityBackground.js